package fr.manyverse.app.presentation.components.common_tabs

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.sizeIn
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material.icons.filled.Palette
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material.icons.filled.TipsAndUpdates
import androidx.compose.foundation.Image
import androidx.compose.ui.layout.ContentScale
import androidx.compose.material3.Button
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.FilledIconToggleButton
import androidx.compose.material3.FilledTonalButton
import androidx.compose.material3.FilterChip
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.withTransform
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import fr.manyverse.app.domain.model.DiceFaceStyle
import fr.manyverse.app.domain.model.DiceOutcome
import fr.manyverse.app.domain.model.DieConfig
import fr.manyverse.app.domain.model.DieType
import fr.manyverse.app.domain.model.outcomeFor
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import fr.manyverse.app.getPlatform
import fr.manyverse.app.presentation.components.clearFocusOnTap
import fr.manyverse.app.presentation.components.dice3d.Dice3DCanvas
import fr.manyverse.app.presentation.dice3d.DiceColor
import fr.manyverse.app.presentation.dice3d.DiceImpact
import fr.manyverse.app.presentation.dice3d.DiceOneFace
import fr.manyverse.app.presentation.dice3d.rememberDiceImpactHaptics
import fr.manyverse.app.presentation.layout.WindowSizeContainer
import fr.manyverse.app.presentation.layout.WindowWidth
import fr.manyverse.app.presentation.theme.success
import fr.manyverse.app.presentation.viewmodel.DiceTrayViewModel
import kotlinx.coroutines.launch
import org.koin.compose.viewmodel.koinViewModel
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.dice_color_label
import manyverse.shared.generated.resources.dice_configure_label
import manyverse.shared.generated.resources.dice_modifier_label
import manyverse.shared.generated.resources.dice_one_face_bomb
import manyverse.shared.generated.resources.dice_one_face_flame
import manyverse.shared.generated.resources.dice_one_face_label
import manyverse.shared.generated.resources.dice_one_face_lightning
import manyverse.shared.generated.resources.dice_one_face_none
import manyverse.shared.generated.resources.dice_one_face_poison
import manyverse.shared.generated.resources.dice_one_face_skull
import manyverse.shared.generated.resources.dice_one_face_swords
import manyverse.shared.generated.resources.dice_quantity_label
import manyverse.shared.generated.resources.dice_rolling_message_1
import manyverse.shared.generated.resources.dice_rolling_message_2
import manyverse.shared.generated.resources.dice_rolling_message_3
import manyverse.shared.generated.resources.dice_rolling_message_4
import manyverse.shared.generated.resources.dice_rolling_message_5
import manyverse.shared.generated.resources.dice_rolling_message_6
import manyverse.shared.generated.resources.dice_rolling_message_7
import manyverse.shared.generated.resources.dice_rolling_message_8
import manyverse.shared.generated.resources.dice_rolling_message_9
import manyverse.shared.generated.resources.dice_tray_color_label
import manyverse.shared.generated.resources.dice_tray_options
import manyverse.shared.generated.resources.roll
import manyverse.shared.generated.resources.shake_to_roll_hint
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import kotlin.math.abs
import kotlin.random.Random

private const val MODIFIER_MAX_ABS = 9999

/** Bas de la zone où les dés se rangent : le reste du plateau accueille les résultats. */
private const val TRAY_SETTLE_BOTTOM_FRACTION = 0.72f

// Couleurs de texte lisibles sur le feutre sombre de la piste de dés.
private val TRAY_TEXT = Color.White
private val TRAY_TEXT_MUTED = Color.White.copy(alpha = 0.82f)
private val TRAY_CRITICAL_SUCCESS = Color(0xFF7CFFB0)
private val TRAY_CRITICAL_FAILURE = Color(0xFFFF8A8A)

/** Lancer en cours ou terminé. Le résultat n'est pas tiré ici : ce sont les dés 3D qui le donnent. */
private data class ActiveRoll(
    val die: DieConfig,
    val count: Int,
    val modifier: Int,
    val seed: Long
)

@OptIn(ExperimentalLayoutApi::class, ExperimentalMaterial3Api::class)
@Composable
fun DiceTab(
    availableDice: List<DieConfig>,
    defaultDie: DieType,
    multiDiceEnabled: Boolean,
    modifiersEnabled: Boolean,
    totalEnabled: Boolean = true,
    faceStyle: DiceFaceStyle = DiceFaceStyle.NUMERALS,
    defaultDiceCount: Int = 1,
    defaultModifier: Int = 0,
    /** Un lancer par secouage est en cours : l'overlay plein écran prend la main. */
    shakeRollActive: Boolean = false,
    onRollCompleted: (dieConfig: DieConfig, count: Int, results: List<Int>, modifier: Int) -> Unit,
    onConfigChanged: (dieConfig: DieConfig, count: Int, modifier: Int) -> Unit = { _, _, _ -> },
    modifier: Modifier = Modifier
) {
    // L'ordre de [availableDice] est celui de la config d'univers, triée par nombre
    // de faces croissant à l'enregistrement (voir UniverseEditForm).
    val initialDie = remember(availableDice, defaultDie) {
        availableDice.firstOrNull { it.type == defaultDie } ?: availableDice.first()
    }
    var selectedDie by remember(initialDie) { mutableStateOf(initialDie) }
    var diceCount by remember(defaultDiceCount) { mutableIntStateOf(defaultDiceCount) }
    var rollResults by remember { mutableStateOf<List<Int>?>(null) }
    var activeRoll by remember { mutableStateOf<ActiveRoll?>(null) }
    var rollModifier by remember { mutableIntStateOf(0) }
    var modifierValue by remember(defaultModifier) { mutableIntStateOf(defaultModifier) }
    var isRolling by remember { mutableStateOf(false) }
    var showSheet by remember { mutableStateOf(false) }

    val rollingMessages = listOf(
        stringResource(Res.string.dice_rolling_message_1),
        stringResource(Res.string.dice_rolling_message_2),
        stringResource(Res.string.dice_rolling_message_3),
        stringResource(Res.string.dice_rolling_message_4),
        stringResource(Res.string.dice_rolling_message_5),
        stringResource(Res.string.dice_rolling_message_6),
        stringResource(Res.string.dice_rolling_message_7),
        stringResource(Res.string.dice_rolling_message_8),
        stringResource(Res.string.dice_rolling_message_9),
    )
    var rollingMessage by remember { mutableStateOf("") }

    val platformName = remember { getPlatform().name }
    val isMobile = platformName.startsWith("Android") || platformName.startsWith("iOS")

    val scope = rememberCoroutineScope()
    val diceHaptics = rememberDiceImpactHaptics()
    val sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)

    val trayViewModel: DiceTrayViewModel = koinViewModel()
    val trayColor by trayViewModel.color.collectAsStateWithLifecycle()
    val diceColor by trayViewModel.diceColor.collectAsStateWithLifecycle()
    // Le choix de l'utilisateur prime ; tant qu'il n'a rien choisi, le style de face de
    // l'univers (réglé par le MJ) sert de valeur initiale.
    val storedOneFace by trayViewModel.oneFace.collectAsStateWithLifecycle()
    val oneFace = storedOneFace ?: DiceOneFace.fromFaceStyle(faceStyle)

    // Aucun résultat n'est tiré ici : les dés roulent librement et la face sur laquelle ils
    // se couchent fait foi (onDiceSettled).
    val performRoll: () -> Unit = performRoll@{
        // Un jet en cours va au bout : relancer maintenant jetterait la simulation en pleine course.
        if (isRolling) return@performRoll
        val effectiveModifier = if (modifiersEnabled) modifierValue else 0
        rollResults = null
        rollingMessage = rollingMessages.random()
        isRolling = true
        activeRoll = ActiveRoll(selectedDie, diceCount, effectiveModifier, Random.nextLong())
        // Aucune vibration n'est jouée ici : ce sont les dés qui feront vibrer l'appareil, chacun
        // de leurs chocs à son tour (voir [rememberDiceImpactHaptics]).
    }

    val onDiceSettled: (List<Int>) -> Unit = { results ->
        activeRoll?.let { roll ->
            // Garde d'idempotence : la simulation peut être relancée (redimensionnement).
            if (rollResults == null && results.isNotEmpty()) {
                isRolling = false
                rollResults = results
                rollModifier = roll.modifier
                onRollCompleted(roll.die, roll.count, results, roll.modifier)
            }
        }
    }

    // Le lancer par secouage vide le plateau : sans ça, le résultat du bouton resterait
    // affiché derrière l'overlay et deux résultats concurrents seraient visibles à sa
    // fermeture. Seul le contenu de l'onglet est effacé, l'overlay garde le sien.
    LaunchedEffect(shakeRollActive) {
        if (shakeRollActive) {
            rollResults = null
            activeRoll = null
            isRolling = false
        }
    }

    LaunchedEffect(selectedDie, diceCount, modifierValue, modifiersEnabled) {
        onConfigChanged(selectedDie, diceCount, if (modifiersEnabled) modifierValue else 0)
    }

    val hasConfiguration = availableDice.size > 1 || multiDiceEnabled || modifiersEnabled

    // Configuration visuelle (couleur des dés, feutre, face « 1 »). Sur mobile elle se
    // place à droite du bandeau ; ailleurs elle coiffe le plateau.
    val trayOptionsMenu: @Composable () -> Unit = {
        DiceTrayOptionsMenu(
            selectedColor = trayColor,
            onColorSelected = trayViewModel::selectColor,
            selectedDiceColor = diceColor,
            onDiceColorSelected = trayViewModel::selectDiceColor,
            selectedOneFace = oneFace,
            onOneFaceSelected = trayViewModel::selectOneFace
        )
    }

    Column(
        modifier = modifier.fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        if (isMobile) {
            // Le bouton de configuration visuelle se place à droite du bandeau, même ligne.
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                MessagesBanner(
                    text = stringResource(Res.string.shake_to_roll_hint),
                    icon = Icons.Default.TipsAndUpdates,
                    modifier = Modifier.weight(1f)
                )
                trayOptionsMenu()
            }
        }

        WindowSizeContainer(modifier = Modifier.fillMaxSize()) { windowWidth ->
            val traySection: @Composable (Modifier) -> Unit = { traySectionModifier ->
                DiceTraySection(
                    trayColor = trayColor,
                    isRolling = isRolling,
                    rollingMessage = rollingMessage,
                    rollResults = rollResults,
                    totalEnabled = totalEnabled,
                    rollModifier = rollModifier,
                    selectedDie = selectedDie,
                    activeRoll = activeRoll,
                    diceColor = diceColor,
                    oneFace = oneFace,
                    onDiceSettled = onDiceSettled,
                    onDiceImpact = diceHaptics,
                    modifier = traySectionModifier
                )
            }
            val configureButton: @Composable (Modifier) -> Unit = { buttonModifier ->
                if (hasConfiguration) {
                    ConfigureButton(
                        diceCount = diceCount,
                        selectedDie = selectedDie,
                        modifierValue = modifierValue,
                        onClick = { showSheet = true },
                        modifier = buttonModifier
                    )
                }
            }

            if (windowWidth == WindowWidth.COMPACT) {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(16.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    if (!isMobile) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.End
                        ) {
                            trayOptionsMenu()
                        }
                    }

                    traySection(Modifier.weight(1f))

                    // Un peu d'air pour que les boutons ne collent pas au bas du plateau.
                    Spacer(Modifier.height(16.dp))

                    // Footer bar: Configure (left) + Roll (right)
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(12.dp, Alignment.CenterHorizontally),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        configureButton(Modifier.weight(1f).height(56.dp))
                        RollButton(
                            onClick = performRoll,
                            enabled = !isRolling,
                            modifier = Modifier.height(56.dp)
                        )
                    }
                }
            } else {
                Row(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(16.dp),
                    horizontalArrangement = Arrangement.spacedBy(16.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    // Left: dice tray with the palette menu on top
                    Column(
                        modifier = Modifier
                            .weight(1f)
                            .fillMaxHeight(),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        if (!isMobile) {
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.End
                            ) {
                                trayOptionsMenu()
                            }
                        }
                        traySection(Modifier.weight(1f))
                    }

                    // Right: action buttons stacked vertically
                    Column(
                        modifier = Modifier
                            .width(220.dp)
                            .fillMaxHeight(),
                        verticalArrangement = Arrangement.spacedBy(12.dp, Alignment.CenterVertically),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        configureButton(Modifier.fillMaxWidth().height(56.dp))
                        RollButton(
                            onClick = performRoll,
                            enabled = !isRolling,
                            modifier = Modifier.fillMaxWidth().height(56.dp)
                        )
                    }
                }
            }
        }
    }

    if (showSheet) {
        ModalBottomSheet(
            modifier = Modifier.clearFocusOnTap(),
            onDismissRequest = { showSheet = false },
            sheetState = sheetState
        ) {
            RollConfigSheet(
                availableDice = availableDice,
                selectedDie = selectedDie,
                onDieSelected = {
                    selectedDie = it
                    rollResults = null
                    // Le lancer en cours est abandonné : sans activeRoll, onDiceSettled ne
                    // pourra plus retomber sur ses pieds et le message resterait affiché.
                    activeRoll = null
                    isRolling = false
                },
                multiDiceEnabled = multiDiceEnabled,
                diceCount = diceCount,
                onDiceCountChange = { diceCount = it },
                modifiersEnabled = modifiersEnabled,
                modifierValue = modifierValue,
                onModifierChange = { modifierValue = it.coerceIn(-MODIFIER_MAX_ABS, MODIFIER_MAX_ABS) },
                rollEnabled = !isRolling,
                onRoll = {
                    performRoll()
                    scope.launch { sheetState.hide() }.invokeOnCompletion { showSheet = false }
                }
            )
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun DiceTraySection(
    trayColor: DiceTrayColor,
    isRolling: Boolean,
    rollingMessage: String,
    rollResults: List<Int>?,
    totalEnabled: Boolean,
    rollModifier: Int,
    selectedDie: DieConfig,
    activeRoll: ActiveRoll?,
    diceColor: DiceColor,
    oneFace: DiceOneFace,
    onDiceSettled: (List<Int>) -> Unit,
    onDiceImpact: (DiceImpact) -> Unit,
    modifier: Modifier = Modifier
) {
    var traySize by remember { mutableStateOf(IntSize.Zero) }
    DiceTray(
        color = trayColor,
        modifier = modifier
            .sizeIn(maxWidth = 480.dp)
            .fillMaxSize()
            .onSizeChanged { traySize = it }
    ) {
        activeRoll?.let { roll ->
            // Un halo coloré souligne les dés critiques une fois rangés au centre du plateau.
            val haloColorFor: (Int) -> Color? = remember(roll) { { trayHaloColor(it, roll.die) } }
            Dice3DCanvas(
                dieType = roll.die.type,
                diceCount = roll.count,
                diceColor = diceColor,
                oneFace = oneFace,
                seed = roll.seed,
                onSettled = onDiceSettled,
                onImpact = onDiceImpact,
                modifier = Modifier.fillMaxSize(),
                // Les faces tournées vers le bas reçoivent le renvoi du feutre : c'est ce qui
                // assoit les dés dans le plateau au lieu de les y coller.
                feltColor = trayColor.center,
                haloColorFor = haloColorFor,
                // Les dés se rangent sous le filigrane et au-dessus des résultats.
                settleTopFraction = trayLogoBottomFraction(
                    color = trayColor,
                    widthPx = traySize.width.toFloat(),
                    heightPx = traySize.height.toFloat()
                ),
                settleBottomFraction = TRAY_SETTLE_BOTTOM_FRACTION
            )
        }
        if (isRolling) {
            Text(
                text = rollingMessage,
                style = MaterialTheme.typography.titleLarge,
                color = TRAY_TEXT,
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .padding(horizontal = 24.dp)
                    .padding(bottom = 24.dp)
            )
        }
        // Résultats en bande basse : les dés arrêtés occupent la partie haute du plateau.
        Column(
            modifier = Modifier
                .align(Alignment.BottomCenter)
                .padding(horizontal = 24.dp)
                .padding(bottom = 24.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            rollResults?.let { results ->
                if (totalEnabled) {
                    val sum = results.sum()
                    val total = sum + rollModifier
                    // Les seuils critiques sont définis par face de dé : on ne colore le
                    // total que lorsqu'il correspond à la valeur naturelle d'un dé unique.
                    // Sinon le détail ci-dessous porte la couleur de chaque dé.
                    val totalIsSingleNaturalDie = results.size == 1 && rollModifier == 0
                    Text(
                        text = total.toString(),
                        style = MaterialTheme.typography.displayLarge,
                        color = if (totalIsSingleNaturalDie) {
                            trayCriticalColor(total, selectedDie)
                        } else {
                            TRAY_TEXT
                        },
                        textAlign = TextAlign.Center
                    )
                    val breakdown = annotatedTotalBreakdown(
                        results = results,
                        sum = sum,
                        modifier = rollModifier,
                        neutralColor = TRAY_TEXT_MUTED,
                        resultColor = { trayCriticalColor(it, selectedDie) }
                    )
                    if (breakdown != null) {
                        Text(
                            text = breakdown,
                            style = MaterialTheme.typography.titleMedium,
                            textAlign = TextAlign.Center,
                            modifier = Modifier.padding(top = 4.dp)
                        )
                    }
                } else {
                    FlowRow(
                        horizontalArrangement = Arrangement.spacedBy(
                            8.dp,
                            Alignment.CenterHorizontally
                        ),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        results.forEachIndexed { index, result ->
                            val value = result + rollModifier
                            Text(
                                text = value.toString(),
                                style = MaterialTheme.typography.displayLarge,
                                color = trayCriticalColor(value, selectedDie),
                                textAlign = TextAlign.Center
                            )
                            if (index < results.size - 1) {
                                Text(
                                    text = " - ",
                                    style = MaterialTheme.typography.displayLarge,
                                    color = TRAY_TEXT,
                                    textAlign = TextAlign.Center
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun ConfigureButton(
    diceCount: Int,
    selectedDie: DieConfig,
    modifierValue: Int,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    FilledTonalButton(
        onClick = onClick,
        modifier = modifier
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(horizontalAlignment = Alignment.Start) {
                Text(
                    text = stringResource(Res.string.dice_configure_label),
                    style = MaterialTheme.typography.labelSmall
                )
                Text(
                    text = rollNotation(diceCount, selectedDie, modifierValue),
                    style = MaterialTheme.typography.titleMedium
                )
            }
            Icon(
                imageVector = Icons.Default.KeyboardArrowUp,
                contentDescription = null
            )
        }
    }
}

@Composable
private fun RollButton(
    onClick: () -> Unit,
    enabled: Boolean = true,
    modifier: Modifier = Modifier
) {
    Button(
        onClick = onClick,
        enabled = enabled,
        modifier = modifier
    ) {
        Text(stringResource(Res.string.roll))
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun RollConfigSheet(
    availableDice: List<DieConfig>,
    selectedDie: DieConfig,
    onDieSelected: (DieConfig) -> Unit,
    multiDiceEnabled: Boolean,
    diceCount: Int,
    onDiceCountChange: (Int) -> Unit,
    modifiersEnabled: Boolean,
    modifierValue: Int,
    onModifierChange: (Int) -> Unit,
    rollEnabled: Boolean,
    onRoll: () -> Unit
) {
    var quantityOpen by remember { mutableStateOf(true) }
    var modifierOpen by remember { mutableStateOf(true) }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp)
            .padding(bottom = 24.dp),
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        // Die type — always visible
        if (availableDice.size > 1) {
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.CenterHorizontally),
                modifier = Modifier.fillMaxWidth()
            ) {
                availableDice.forEach { die ->
                    FilterChip(
                        selected = selectedDie == die,
                        onClick = { onDieSelected(die) },
                        label = { Text(die.type.name) }
                    )
                }
            }
        }

        // Quantity — collapsible, expanded by default
        if (multiDiceEnabled) {
            CollapsibleRow(
                label = stringResource(Res.string.dice_quantity_label),
                value = "× $diceCount",
                open = quantityOpen,
                onToggle = { quantityOpen = !quantityOpen }
            ) {
                FlowRow(
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    (1..10).forEach { n ->
                        FilterChip(
                            selected = diceCount == n,
                            onClick = { onDiceCountChange(n) },
                            label = { Text("$n") }
                        )
                    }
                }
            }
        }

        // Modifier — collapsible, expanded by default
        if (modifiersEnabled) {
            val modifierColor = when {
                modifierValue > 0 -> MaterialTheme.colorScheme.success
                modifierValue < 0 -> MaterialTheme.colorScheme.error
                else -> MaterialTheme.colorScheme.onSurfaceVariant
            }
            val modifierLabel = when {
                modifierValue > 0 -> "+$modifierValue"
                else -> modifierValue.toString()
            }
            CollapsibleRow(
                label = stringResource(Res.string.dice_modifier_label),
                value = modifierLabel,
                valueColor = modifierColor,
                open = modifierOpen,
                onToggle = { modifierOpen = !modifierOpen }
            ) {
                ModifierRow(value = modifierValue, onValueChange = onModifierChange)
            }
        }

        Button(
            onClick = onRoll,
            enabled = rollEnabled,
            modifier = Modifier
                .align(Alignment.CenterHorizontally)
                .padding(top = 8.dp)
        ) {
            Text(stringResource(Res.string.roll))
        }
    }
}

@Composable
private fun CollapsibleRow(
    label: String,
    value: String,
    valueColor: Color? = null,
    open: Boolean,
    onToggle: () -> Unit,
    content: @Composable () -> Unit
) {
    val chevronRotation by animateFloatAsState(targetValue = if (open) 180f else 0f)
    Column(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clickable(onClick = onToggle)
                .padding(vertical = 8.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(text = label, style = MaterialTheme.typography.titleSmall)
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    text = value,
                    style = MaterialTheme.typography.titleMedium,
                    color = valueColor ?: MaterialTheme.colorScheme.onSurface
                )
                Icon(
                    imageVector = Icons.Default.KeyboardArrowDown,
                    contentDescription = null,
                    modifier = Modifier
                        .padding(start = 8.dp)
                        .rotate(chevronRotation),
                    tint = MaterialTheme.colorScheme.onSurfaceVariant
                )
            }
        }
        AnimatedVisibility(visible = open) {
            Box(modifier = Modifier.padding(bottom = 8.dp)) {
                content()
            }
        }
    }
}

/**
 * Récap coloré du total : `d1 + d2 = sum ± mod`. Chaque résultat individuel reçoit la couleur
 * de son issue critique via [resultColor], tandis que les opérateurs, la somme et le
 * modificateur restent en [neutralColor]. Retourne null quand un seul dé sans modificateur
 * (le grand total suffit).
 */
internal fun annotatedTotalBreakdown(
    results: List<Int>,
    sum: Int,
    modifier: Int,
    neutralColor: Color,
    resultColor: (Int) -> Color
): AnnotatedString? {
    if (results.size <= 1 && modifier == 0) return null
    return buildAnnotatedString {
        if (results.size > 1) {
            results.forEachIndexed { index, result ->
                withStyle(SpanStyle(color = resultColor(result))) { append(result.toString()) }
                if (index < results.size - 1) {
                    withStyle(SpanStyle(color = neutralColor)) { append(" + ") }
                }
            }
            withStyle(SpanStyle(color = neutralColor)) { append(" = $sum") }
        } else {
            // Dé unique avec modificateur : la somme est la valeur naturelle du dé.
            withStyle(SpanStyle(color = resultColor(sum))) { append(sum.toString()) }
        }
        if (modifier != 0) {
            val sign = if (modifier >= 0) "+" else "−"
            withStyle(SpanStyle(color = neutralColor)) { append(" $sign ${abs(modifier)}") }
        }
    }
}

private fun rollNotation(count: Int, die: DieConfig, modifier: Int): String {
    val base = "${count}d${die.type.sides}"
    return when {
        modifier > 0 -> "$base+$modifier"
        modifier < 0 -> "$base−${abs(modifier)}"
        else -> base
    }
}

@Composable
private fun criticalColor(value: Int, die: DieConfig): Color = when (die.outcomeFor(value)) {
    DiceOutcome.CRITICAL_SUCCESS -> MaterialTheme.colorScheme.success
    DiceOutcome.CRITICAL_FAILURE -> MaterialTheme.colorScheme.error
    DiceOutcome.NORMAL -> MaterialTheme.colorScheme.onSurface
}

/** Variante de [criticalColor] avec des teintes lisibles sur le feutre sombre de la piste. */
private fun trayCriticalColor(value: Int, die: DieConfig): Color = when (die.outcomeFor(value)) {
    DiceOutcome.CRITICAL_SUCCESS -> TRAY_CRITICAL_SUCCESS
    DiceOutcome.CRITICAL_FAILURE -> TRAY_CRITICAL_FAILURE
    DiceOutcome.NORMAL -> TRAY_TEXT
}

/** Halo du dé 3D posé : même teinte que le résultat, rien pour une valeur neutre. */
private fun trayHaloColor(value: Int, die: DieConfig): Color? = when (die.outcomeFor(value)) {
    DiceOutcome.CRITICAL_SUCCESS -> TRAY_CRITICAL_SUCCESS
    DiceOutcome.CRITICAL_FAILURE -> TRAY_CRITICAL_FAILURE
    DiceOutcome.NORMAL -> null
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun DiceTrayOptionsMenu(
    selectedColor: DiceTrayColor,
    onColorSelected: (DiceTrayColor) -> Unit,
    selectedDiceColor: DiceColor,
    onDiceColorSelected: (DiceColor) -> Unit,
    selectedOneFace: DiceOneFace,
    onOneFaceSelected: (DiceOneFace) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }
    Box {
        IconButton(onClick = { expanded = true }) {
            Icon(
                imageVector = Icons.Default.Palette,
                contentDescription = stringResource(Res.string.dice_tray_options)
            )
        }
        DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
            Column(
                modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Text(
                    text = stringResource(Res.string.dice_tray_color_label),
                    style = MaterialTheme.typography.labelLarge
                )
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    DiceTrayColor.entries.forEach { color ->
                        val selected = color == selectedColor
                        Box(
                            modifier = Modifier
                                .size(34.dp)
                                .clip(CircleShape)
                                .background(color.center)
                                .border(
                                    width = if (selected) 3.dp else 1.dp,
                                    color = if (selected) {
                                        MaterialTheme.colorScheme.primary
                                    } else {
                                        MaterialTheme.colorScheme.outlineVariant
                                    },
                                    shape = CircleShape
                                )
                                .clickable { onColorSelected(color) },
                            contentAlignment = Alignment.Center
                        ) {
                            color.logoRes?.let { res ->
                                Image(
                                    painter = painterResource(res),
                                    contentDescription = null,
                                    contentScale = ContentScale.Fit,
                                    modifier = Modifier
                                        .padding(4.dp)
                                        .fillMaxSize()
                                )
                            }
                        }
                    }
                }
                Text(
                    text = stringResource(Res.string.dice_color_label),
                    style = MaterialTheme.typography.labelLarge
                )
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    DiceColor.entries.forEach { color ->
                        val selected = color == selectedDiceColor
                        Box(
                            modifier = Modifier
                                .size(34.dp)
                                .clip(CircleShape)
                                .background(color.body)
                                .border(
                                    width = if (selected) 3.dp else 1.dp,
                                    color = if (selected) {
                                        MaterialTheme.colorScheme.primary
                                    } else {
                                        MaterialTheme.colorScheme.outlineVariant
                                    },
                                    shape = CircleShape
                                )
                                .clickable { onDiceColorSelected(color) },
                            contentAlignment = Alignment.Center
                        ) {
                            // Point central : aperçu du contraste corps / chiffres.
                            Box(
                                modifier = Modifier
                                    .size(10.dp)
                                    .clip(CircleShape)
                                    .background(color.pip)
                            )
                        }
                    }
                }
                Text(
                    text = stringResource(Res.string.dice_one_face_label),
                    style = MaterialTheme.typography.labelLarge
                )
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    DiceOneFace.entries.forEach { face ->
                        DiceOneFaceSwatch(
                            face = face,
                            selected = face == selectedOneFace,
                            onClick = { onOneFaceSelected(face) }
                        )
                    }
                }
            }
        }
    }
}

/**
 * Pastille d'aperçu d'une image de face « 1 » : le glyphe est tracé depuis la même géométrie
 * que le rendu 3D, pour qu'aucun visuel ne vive en double. [DiceOneFace.NONE] montre le chiffre.
 */
@Composable
private fun DiceOneFaceSwatch(
    face: DiceOneFace,
    selected: Boolean,
    onClick: () -> Unit
) {
    val background = MaterialTheme.colorScheme.surfaceVariant
    val foreground = MaterialTheme.colorScheme.onSurfaceVariant
    val label = stringResource(face.labelRes())
    Box(
        modifier = Modifier
            .size(34.dp)
            .clip(CircleShape)
            .background(background)
            .border(
                width = if (selected) 3.dp else 1.dp,
                color = if (selected) {
                    MaterialTheme.colorScheme.primary
                } else {
                    MaterialTheme.colorScheme.outlineVariant
                },
                shape = CircleShape
            )
            .clickable(onClick = onClick)
            .semantics { contentDescription = label },
        contentAlignment = Alignment.Center
    ) {
        val glyph = face.glyph
        if (glyph == null) {
            Text(text = "1", style = MaterialTheme.typography.titleMedium, color = foreground)
        } else {
            Canvas(modifier = Modifier.size(20.dp)) {
                // Le glyphe est tracé en espace unité [-1, 1]² : on le recentre et l'échelonne.
                withTransform({
                    translate(size.width / 2f, size.height / 2f)
                    scale(size.minDimension / 2f, size.minDimension / 2f, Offset.Zero)
                    translate(0f, glyph.centerOffsetY)
                }) {
                    drawPath(glyph.fill, foreground)
                    glyph.hollows?.let { drawPath(it, background) }
                }
            }
        }
    }
}

private fun DiceOneFace.labelRes(): StringResource = when (this) {
    DiceOneFace.NONE -> Res.string.dice_one_face_none
    DiceOneFace.SKULL -> Res.string.dice_one_face_skull
    DiceOneFace.BOMB -> Res.string.dice_one_face_bomb
    DiceOneFace.SWORDS -> Res.string.dice_one_face_swords
    DiceOneFace.LIGHTNING -> Res.string.dice_one_face_lightning
    DiceOneFace.FLAME -> Res.string.dice_one_face_flame
    DiceOneFace.POISON -> Res.string.dice_one_face_poison
}

@Composable
private fun ModifierRow(
    value: Int,
    onValueChange: (Int) -> Unit
) {
    val isPositive = value >= 0
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.fillMaxWidth()
    ) {
        Text(
            text = stringResource(Res.string.dice_modifier_label),
            style = MaterialTheme.typography.titleSmall
        )
        Spacer(modifier = Modifier.height(4.dp))
        Row(
            horizontalArrangement = Arrangement.spacedBy(4.dp, Alignment.CenterHorizontally),
            verticalAlignment = Alignment.CenterVertically
        ) {
            FilledIconToggleButton(
                checked = isPositive,
                onCheckedChange = { if (it) onValueChange(abs(value)) },
                modifier = Modifier.size(36.dp)
            ) {
                Text("+", style = MaterialTheme.typography.titleMedium)
            }
            FilledIconToggleButton(
                checked = !isPositive,
                onCheckedChange = { if (it) onValueChange(-abs(value)) },
                modifier = Modifier.size(36.dp)
            ) {
                Text("−", style = MaterialTheme.typography.titleMedium)
            }
            IconButton(
                onClick = { onValueChange(0) },
                enabled = value != 0,
                modifier = Modifier.size(36.dp)
            ) {
                Icon(
                    imageVector = Icons.Default.Refresh,
                    contentDescription = null
                )
            }
        }
        Spacer(modifier = Modifier.height(4.dp))
        Row(
            horizontalArrangement = Arrangement.spacedBy(4.dp, Alignment.CenterHorizontally),
            verticalAlignment = Alignment.CenterVertically
        ) {
            ModifierStepButton(label = "−5", onClick = { onValueChange(value - 5) })
            ModifierStepButton(label = "−1", onClick = { onValueChange(value - 1) })
            OutlinedTextField(
                value = value.toString(),
                onValueChange = { input ->
                    val sanitized = input.filter { it.isDigit() || it == '-' }
                    if (sanitized.isEmpty() || sanitized == "-") {
                        onValueChange(0)
                    } else {
                        sanitized.toIntOrNull()?.let { parsed ->
                            if (abs(parsed) <= MODIFIER_MAX_ABS) onValueChange(parsed)
                        }
                    }
                },
                singleLine = true,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                textStyle = MaterialTheme.typography.titleMedium.copy(textAlign = TextAlign.Center),
                modifier = Modifier.width(96.dp)
            )
            ModifierStepButton(label = "+1", onClick = { onValueChange(value + 1) })
            ModifierStepButton(label = "+5", onClick = { onValueChange(value + 5) })
        }
    }
}

@Composable
private fun ModifierStepButton(label: String, onClick: () -> Unit) {
    OutlinedButton(
        onClick = onClick,
        contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 8.dp, vertical = 4.dp),
        modifier = Modifier.size(width = 44.dp, height = 36.dp)
    ) {
        Text(label, style = MaterialTheme.typography.labelMedium)
    }
}
